import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { StatusFormComponent } from './status-form.component';
import { SharedModule } from '../../../shared/shared.module';
import { GlobalModule } from '../../../../../global/global.module';

@NgModule({
    declarations: [StatusFormComponent],
    imports: [CommonModule, ReactiveFormsModule, MatIconModule, MatButtonModule, MatCheckboxModule, TranslateModule, SharedModule, GlobalModule],
    exports: [StatusFormComponent],
})
export class StatusFormModule {}
